import { render, staticRenderFns } from "./LcaRawMaterial.vue?vue&type=template&id=9c9dec34"
import script from "./LcaRawMaterial.vue?vue&type=script&lang=js"
export * from "./LcaRawMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports